var $6e5e196223df6786$exports = {};
var $6e5e196223df6786$var$sketch = Sketch.create(), $6e5e196223df6786$var$center = {
    x: $6e5e196223df6786$var$sketch.width / 2,
    y: $6e5e196223df6786$var$sketch.height / 2
}, $6e5e196223df6786$var$orbs = [], $6e5e196223df6786$var$dt = 1, $6e5e196223df6786$var$opt = {
    total: 0,
    count: 100,
    spacing: 2,
    speed: 65,
    scale: 1,
    jitterRadius: 0,
    jitterHue: 0,
    clearAlpha: 10,
    toggleOrbitals: true,
    orbitalAlpha: 100,
    toggleLight: true,
    lightAlpha: 5,
    clear: function() {
        $6e5e196223df6786$var$sketch.clearRect(0, 0, $6e5e196223df6786$var$sketch.width, $6e5e196223df6786$var$sketch.height), $6e5e196223df6786$var$orbs.length = 0;
    }
};
var $6e5e196223df6786$var$Orb = function(x, y) {
    var dx = x / $6e5e196223df6786$var$opt.scale - $6e5e196223df6786$var$center.x / $6e5e196223df6786$var$opt.scale, dy = y / $6e5e196223df6786$var$opt.scale - $6e5e196223df6786$var$center.y / $6e5e196223df6786$var$opt.scale;
    this.angle = atan2(dy, dx);
    this.lastAngle = this.angle;
    this.radius = sqrt(dx * dx + dy * dy);
    console.log(this.radius);
    this.size = this.radius / 300 + 1;
    this.speed = random(1, 10) / 300000 * this.radius + 0.015;
};
$6e5e196223df6786$var$Orb.prototype.update = function() {
    this.lastAngle = this.angle;
    this.angle += this.speed * ($6e5e196223df6786$var$opt.speed / 50) * $6e5e196223df6786$var$dt;
    this.x = this.radius * cos(this.angle);
    this.y = this.radius * sin(this.angle);
};
$6e5e196223df6786$var$Orb.prototype.render = function() {
    if ($6e5e196223df6786$var$opt.toggleOrbitals) {
        var radius = $6e5e196223df6786$var$opt.jitterRadius === 0 ? this.radius : this.radius + random(-$6e5e196223df6786$var$opt.jitterRadius, $6e5e196223df6786$var$opt.jitterRadius);
        radius = $6e5e196223df6786$var$opt.jitterRadius != 0 && radius < 0 ? 0.001 : radius;
        $6e5e196223df6786$var$sketch.strokeStyle = 'hsla( ' + ((this.angle + 90) / (PI / 180) + random(-$6e5e196223df6786$var$opt.jitterHue, $6e5e196223df6786$var$opt.jitterHue)) + ', 100%, 50%, ' + $6e5e196223df6786$var$opt.orbitalAlpha / 100 + ' )';
        $6e5e196223df6786$var$sketch.lineWidth = this.size;
        $6e5e196223df6786$var$sketch.beginPath();
        if ($6e5e196223df6786$var$opt.speed >= 0) $6e5e196223df6786$var$sketch.arc(0, 0, radius, this.lastAngle, this.angle + 0.001, false);
        else $6e5e196223df6786$var$sketch.arc(0, 0, radius, this.angle, this.lastAngle + 0.001, false);
        $6e5e196223df6786$var$sketch.stroke();
        $6e5e196223df6786$var$sketch.closePath();
    }
    if ($6e5e196223df6786$var$opt.toggleLight) {
        $6e5e196223df6786$var$sketch.lineWidth = .5;
        $6e5e196223df6786$var$sketch.strokeStyle = 'hsla( ' + ((this.angle + 90) / (PI / 180) + random(-$6e5e196223df6786$var$opt.jitterHue, $6e5e196223df6786$var$opt.jitterHue)) + ', 100%, 70%, ' + $6e5e196223df6786$var$opt.lightAlpha / 100 + ' )';
        $6e5e196223df6786$var$sketch.beginPath();
        $6e5e196223df6786$var$sketch.moveTo(0, 0);
        $6e5e196223df6786$var$sketch.lineTo(this.x, this.y);
        $6e5e196223df6786$var$sketch.stroke();
    }
};
var $6e5e196223df6786$var$createOrb = function(config) {
    var x = config && config.x ? config.x : $6e5e196223df6786$var$sketch.mouse.x, y = config && config.y ? config.y : $6e5e196223df6786$var$sketch.mouse.y;
    console.log("Create orb", `${x} et ${y}`);
    $6e5e196223df6786$var$orbs.push(new $6e5e196223df6786$var$Orb(x, y));
};
var $6e5e196223df6786$var$turnOnMove = function() {
    $6e5e196223df6786$var$sketch.mousemove = $6e5e196223df6786$var$createOrb;
};
var $6e5e196223df6786$var$turnOffMove = function() {
    $6e5e196223df6786$var$sketch.mousemove = null;
};
$6e5e196223df6786$var$sketch.mousedown = function() {
    $6e5e196223df6786$var$createOrb();
    $6e5e196223df6786$var$turnOnMove();
};
$6e5e196223df6786$var$sketch.mouseup = $6e5e196223df6786$var$turnOffMove;
$6e5e196223df6786$var$sketch.resize = function() {
    $6e5e196223df6786$var$center.x = $6e5e196223df6786$var$sketch.width / 2;
    $6e5e196223df6786$var$center.y = $6e5e196223df6786$var$sketch.height / 2;
    $6e5e196223df6786$var$sketch.lineCap = 'round';
};
$6e5e196223df6786$var$sketch.setup = function() {
    while($6e5e196223df6786$var$opt.count--)$6e5e196223df6786$var$createOrb({
        x: random($6e5e196223df6786$var$sketch.width / 2 - 300, $6e5e196223df6786$var$sketch.width / 2 + 300),
        y: random($6e5e196223df6786$var$sketch.height / 2 - 300, $6e5e196223df6786$var$sketch.height / 2 + 300)
    });
};
$6e5e196223df6786$var$sketch.clear = function() {
    $6e5e196223df6786$var$sketch.globalCompositeOperation = 'destination-out';
    $6e5e196223df6786$var$sketch.fillStyle = 'rgba( 0, 0, 0 , ' + $6e5e196223df6786$var$opt.clearAlpha / 100 + ' )';
    $6e5e196223df6786$var$sketch.fillRect(0, 0, $6e5e196223df6786$var$sketch.width, $6e5e196223df6786$var$sketch.height);
    $6e5e196223df6786$var$sketch.globalCompositeOperation = 'lighter';
};
$6e5e196223df6786$var$sketch.update = function() {
    $6e5e196223df6786$var$dt = $6e5e196223df6786$var$sketch.dt < 0.1 ? 0.1 : $6e5e196223df6786$var$sketch.dt / 16;
    $6e5e196223df6786$var$dt = $6e5e196223df6786$var$dt > 5 ? 5 : $6e5e196223df6786$var$dt;
    var i = $6e5e196223df6786$var$orbs.length;
    $6e5e196223df6786$var$opt.total = i;
    while(i--)$6e5e196223df6786$var$orbs[i].update();
};
$6e5e196223df6786$var$sketch.draw = function() {
    $6e5e196223df6786$var$sketch.save();
    $6e5e196223df6786$var$sketch.translate($6e5e196223df6786$var$center.x, $6e5e196223df6786$var$center.y);
    $6e5e196223df6786$var$sketch.scale($6e5e196223df6786$var$opt.scale, $6e5e196223df6786$var$opt.scale);
    var i = $6e5e196223df6786$var$orbs.length;
    while(i--)$6e5e196223df6786$var$orbs[i].render();
    $6e5e196223df6786$var$sketch.restore();
};
gui = new dat.GUI({
    autoPlace: false
});
gui.add($6e5e196223df6786$var$opt, 'total').name('Total Orbitals').listen();
gui.add($6e5e196223df6786$var$opt, 'speed').min(-300).max(300).step(1).name('Speed');
gui.add($6e5e196223df6786$var$opt, 'scale').min(0.5).max(5).step(0.001).name('Scale');
gui.add($6e5e196223df6786$var$opt, 'jitterRadius').min(0).max(5).step(0.001).name('Radius Jitter');
gui.add($6e5e196223df6786$var$opt, 'jitterHue').min(0).max(90).step(1).name('Hue Jitter');
gui.add($6e5e196223df6786$var$opt, 'clearAlpha').min(0).max(100).step(1).name('Clear Alpha');
gui.add($6e5e196223df6786$var$opt, 'toggleOrbitals').name('Toggle Orbitals');
gui.add($6e5e196223df6786$var$opt, 'orbitalAlpha').min(0).max(100).step(1).name('Orbital Alpha');
gui.add($6e5e196223df6786$var$opt, 'toggleLight').name('Toggle Light');
gui.add($6e5e196223df6786$var$opt, 'lightAlpha').min(0).max(100).step(1).name('Light Alpha');
gui.add($6e5e196223df6786$var$opt, 'clear').name('Clear');
customContainer = document.getElementById('gui');
customContainer.appendChild(gui.domElement);
document.onselectstart = function() {
    return false;
};


//# sourceMappingURL=index.32cf56a3.js.map
